export interface ChartDisplaySettings {
  background: boolean;
  closeButton: boolean;
  caption: boolean;
  legend: boolean;
  values: boolean;
  grid: boolean;
  axis: boolean;
  tooltip: boolean;
  multipleCharts: boolean;
  divider: boolean;
  chartTitle: boolean;
  chartSizeControls: boolean;
}

const STORAGE_KEY = "poc-gis.chart-display-settings";
export const DEFAULT_CHART_DISPLAY_SETTINGS: ChartDisplaySettings = {
  background: true, closeButton: true, caption: true, legend: true, values: true,
  grid: true, axis: true, tooltip: true, multipleCharts: true, divider: true, chartTitle: true, chartSizeControls: true
};

export class ChartDisplaySettingsStore {
  private settings = this.read();
  private listeners = new Set<(settings: ChartDisplaySettings) => void>();

  get(): ChartDisplaySettings { return { ...this.settings }; }

  set(name: keyof ChartDisplaySettings, value: boolean): void {
    this.settings = { ...this.settings, [name]: value };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(this.settings)); } catch { /* private browsing can disable storage */ }
    this.listeners.forEach((listener) => listener(this.get()));
  }

  resetToDefaults(): void {
    this.settings = { ...DEFAULT_CHART_DISPLAY_SETTINGS };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(this.settings)); } catch { /* private browsing can disable storage */ }
    this.listeners.forEach((listener) => listener(this.get()));
  }

  subscribe(listener: (settings: ChartDisplaySettings) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  renderPanel(): HTMLElement {
    const panel = document.createElement("section");
    panel.className = "chart-display-settings";
    panel.innerHTML = `<h2>Chart Display</h2><div class="chart-display-settings__options"></div>`;
    const labels: Record<keyof ChartDisplaySettings, string> = {
      background: "Background", closeButton: "Close button", caption: "Caption", legend: "Legend",
      values: "Values", grid: "Grid", axis: "Axis", tooltip: "Tooltip", multipleCharts: "Multiple Charts", divider: "Header divider", chartTitle: "Chart title", chartSizeControls: "Chart size controls"
    };
    const options = panel.querySelector(".chart-display-settings__options") as HTMLElement;
    (Object.keys(labels) as Array<keyof ChartDisplaySettings>).forEach((name) => {
      const label = document.createElement("label"); label.className = "checkbox";
      const input = document.createElement("input"); input.type = "checkbox"; input.checked = this.settings[name];
      input.setAttribute("aria-label", labels[name]); input.addEventListener("change", () => this.set(name, input.checked));
      label.append(input, document.createTextNode(labels[name])); options.append(label);
    });
    return panel;
  }

  private read(): ChartDisplaySettings {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}") as Partial<ChartDisplaySettings>;
      return { ...DEFAULT_CHART_DISPLAY_SETTINGS, ...stored };
    } catch { return { ...DEFAULT_CHART_DISPLAY_SETTINGS }; }
  }
}
